import { inr, num } from "@/lib/api";

export const ReportView = ({ result, pmay }) => {
  if (!result) return null;
  const date = new Date(result.generated_at).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <div id="print-report">
      <div style={{ borderBottom: "3px solid #F97316", paddingBottom: 12, marginBottom: 20 }}>
        <h1 style={{ fontSize: 26, fontWeight: 800, color: "#0f172a", margin: 0 }}>
          Nirman<span style={{ color: "#F97316" }}>Dwar</span>
          <span style={{ fontSize: 14, verticalAlign: "super" }}>™</span> — Construction Estimate
        </h1>
        <p style={{ color: "#64748b", margin: "4px 0 0", fontSize: 13 }}>
          Generated on {date} · nirmandwar.com
        </p>
      </div>

      <table style={{ width: "100%", fontSize: 13, marginBottom: 20 }}>
        <tbody>
          {[
            ["City", result.inputs.city],
            ["Quality Tier", result.inputs.quality],
            ["Built-up Area", `${inr(result.inputs.builtup_area)} sq.ft/floor × ${result.inputs.floors} = ${inr(result.inputs.total_area)} sq.ft`],
            ["Foundation", result.inputs.foundation],
            ["Flooring", result.inputs.flooring],
            ["Rate", `₹${inr(result.cost_per_sqft)} / sq.ft`],
          ].map(([k, v]) => (
            <tr key={k}>
              <td style={{ padding: "4px 8px", color: "#64748b", width: 160 }}>{k}</td>
              <td style={{ padding: "4px 8px", color: "#0f172a", fontWeight: 600 }}>{v}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div
        style={{
          background: "#FFF7ED",
          border: "1px solid #FED7AA",
          borderRadius: 10,
          padding: 16,
          marginBottom: 20,
        }}
      >
        <p style={{ margin: 0, color: "#9a3412", fontSize: 13, fontWeight: 600 }}>
          Total Estimated Construction Cost
        </p>
        <p style={{ margin: "4px 0 0", fontSize: 30, fontWeight: 800, color: "#EA580C" }}>
          ₹{inr(result.total_cost)}
        </p>
      </div>

      <h3 style={{ fontSize: 15, color: "#0f172a", margin: "0 0 8px" }}>Cost Breakdown</h3>
      <table style={{ width: "100%", fontSize: 13, borderCollapse: "collapse", marginBottom: 20 }}>
        <thead>
          <tr style={{ background: "#f1f5f9" }}>
            <th style={{ textAlign: "left", padding: 8 }}>Component</th>
            <th style={{ textAlign: "right", padding: 8 }}>%</th>
            <th style={{ textAlign: "right", padding: 8 }}>Amount</th>
          </tr>
        </thead>
        <tbody>
          {result.breakdown.map((b) => (
            <tr key={b.key} style={{ borderBottom: "1px solid #e2e8f0" }}>
              <td style={{ padding: 8 }}>{b.label}</td>
              <td style={{ padding: 8, textAlign: "right" }}>{b.pct}%</td>
              <td style={{ padding: 8, textAlign: "right", fontWeight: 600 }}>₹{inr(b.amount)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3 style={{ fontSize: 15, color: "#0f172a", margin: "0 0 8px" }}>Material Quantities</h3>
      <table style={{ width: "100%", fontSize: 13, borderCollapse: "collapse", marginBottom: 20 }}>
        <thead>
          <tr style={{ background: "#f1f5f9" }}>
            <th style={{ textAlign: "left", padding: 8 }}>Material</th>
            <th style={{ textAlign: "right", padding: 8 }}>Quantity</th>
            <th style={{ textAlign: "right", padding: 8 }}>Est. Cost</th>
          </tr>
        </thead>
        <tbody>
          {result.materials.map((m) => (
            <tr key={m.key} style={{ borderBottom: "1px solid #e2e8f0" }}>
              <td style={{ padding: 8 }}>{m.label}</td>
              <td style={{ padding: 8, textAlign: "right" }}>
                {num(m.quantity)} {m.unit}
              </td>
              <td style={{ padding: 8, textAlign: "right", fontWeight: 600 }}>₹{inr(m.cost)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {pmay && pmay.eligible && (
        <div
          style={{
            background: "#ECFDF5",
            border: "1px solid #A7F3D0",
            borderRadius: 10,
            padding: 16,
            marginBottom: 20,
          }}
        >
          <p style={{ margin: 0, color: "#065f46", fontSize: 13, fontWeight: 600 }}>
            PMAY Interest Subsidy ({pmay.category_id ? pmay.category_id.toUpperCase() : ""})
          </p>
          <p style={{ margin: "4px 0", fontSize: 22, fontWeight: 800, color: "#059669" }}>
            − ₹{inr(pmay.estimated_subsidy)}
          </p>
          <p style={{ margin: 0, color: "#0f172a", fontSize: 14 }}>
            Net cost after subsidy:{" "}
            <b>₹{inr(result.total_cost - pmay.estimated_subsidy)}</b>
          </p>
        </div>
      )}


      <p style={{ fontSize: 11, color: "#94a3b8", marginTop: 24 }}>
        Disclaimer: This is an indicative estimate based on standard Indian construction benchmarks
        (IS Code / CPWD thumb rules). Actual costs vary by design, site conditions & market rates.
        © NirmanDwar · nirmandwar.com
      </p>
    </div>
  );
};
